import * as actions from './rel-save.actions';

import { createFeature, createReducer, createSelector, on } from '@ngrx/store';

import { RelSaveQueryI } from '../../api/rel-save/rel-save.query.int';
import { RelSaveResponseI } from '../../api/rel-save/rel-save.query.result.int';
import { SharedPageTypeEnum } from 'src/app/shared/navigation/page-type.enum';

interface StateObjectI {
  data: RelSaveResponseI;
  errorMessage: string;
  loaded: boolean;
  loading: boolean;
  query: RelSaveQueryI;
}

export interface State {
  lastUsedPageType: SharedPageTypeEnum;
  [SharedPageTypeEnum.quaRelocate]: StateObjectI;
  [SharedPageTypeEnum.infCnt]: StateObjectI;
  [SharedPageTypeEnum.ord]: StateObjectI;
  [SharedPageTypeEnum.ordAutomaticShuffle]: StateObjectI;
}

export const initialState: State = {
  lastUsedPageType: null,
  [SharedPageTypeEnum.ordAutomaticShuffle]: {
    data: null,
    errorMessage: null,
    loaded: null,
    loading: null,
    query: null,
  },
  [SharedPageTypeEnum.quaRelocate]: {
    data: null,
    errorMessage: null,
    loaded: null,
    loading: null,
    query: null,
  },
  [SharedPageTypeEnum.infCnt]: {
    data: null,
    errorMessage: null,
    loaded: null,
    loading: null,
    query: null,
  },
  [SharedPageTypeEnum.ord]: {
    data: null,
    errorMessage: null,
    loaded: null,
    loading: null,
    query: null,
  },
};

export default createFeature({
  name: 'relSave',
  extraSelectors: ({ selectRelSaveState }) => ({
    selectDataForPageType: (pageType: SharedPageTypeEnum) => createSelector(
      selectRelSaveState,
      (state) => (state[pageType] as StateObjectI).data,
    ),
    selectLoadedForPageType: (pageType: SharedPageTypeEnum) => createSelector(
      selectRelSaveState,
      (state) => (state[pageType] as StateObjectI).loaded,
    ),
    selectLoadingForPageType: (pageType: SharedPageTypeEnum) => createSelector(
      selectRelSaveState,
      (state) => (state[pageType] as StateObjectI).loading,
    ),
  }),
  reducer: createReducer(
    initialState,
    on(actions.error, (state: State, { pageType, messageText }): State => ({
      ...state,
      [pageType]: {
        ...state[pageType],
        loading: false,
        errorMessage: messageText
      }
    })),
    on(actions.load, (state: State, { pageType, query }): State => ({
      ...state,
      lastUsedPageType: pageType,
      [pageType]: {
        ...state[pageType],
        loading: true,
        query,
      }
    })),
    on(actions.received, (state: State, { pageType, data }): State => ({
      ...state,
      [pageType]: {
        ...state[pageType],
        loaded: true,
        loading: false,
        data,
      }
    })),
    on(actions.reset, (_state: State, { }): State => ({
      ...initialState,
    })),
  )
}
);
